import React from 'react';
import ReactPlayer from 'react-player';

const styles = {
    subSectionHeader: {
        fontSize: 12,
        color: '#30ACFF',
        weight: 600,
        textAlign: 'center',
        margin: 10
    },
    sectionText: {
        textAlign: 'left',
        margin: 20
    },
    formStyle: {
        width: '80%',
        marginLeft: '10%',
        marginRight: '10%'
    },
    customWidth: {
        width: 200,
    },
    links: {
        color: '#30ACFF',
        fontWeight: 600,
        fontSize: 14
    },
    subTitle: {
        color: "black",
        fontSize: 14,
        width: "80%",
        marginLeft: "10%",
        marginRight: "10%"
    },
    divider: {
        height: 2,
        width: "80%",
        marginLeft: "10%",
        marginRight: "10%",
        backgroundColor: "#30ACFF",
        marginTop: 20,
        marginBotton: 20
    },
    videoPaperStyle: {
        background: '#efefef',
        opacity: 1,
        paddingBottom: 25,
        paddingTop: 10,
        marginTop: 20,
        borderRadius: 20,
        borderStyle: 'groove',
        borderWidth: 5,
        width: '90%',
        marginRight: '5%',
        marginLeft: '5%'
    },
    videoHeader: {
        color: "#4a87c4",
        fontSize: 30,
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: 1.0
    },
    textStyle: {
        textAlign: "left",
        marginTop: 15,
        marginBottom: 15,
        lineHeight: 1.5,
        fontSize: 16

    },
    videoPlayer: { textAlign: "center", background: "white", width: "100%", marginLeft: 'auto', marginRight: 'auto', opacity: 1.0 }
}

export function generateText(content, index){
    return (
        <div key={'contentItem-' + index} style={styles.textStyle}>
            {content}
        </div>
    )
}
export function generateImage(content, index, refFileObj) {
    var element = refFileObj.find(function (element) {
        return element.ID == content.split("%").join('');
    });
    var path = element.path;
    return (
        <div key={'contentItem-' + index} style={{ textAlign: "center", marginTop: 15 }}>
            <img src={require('../../../' + path)} height={element.size.height} width={element.size.width} />
        </div>
    )
}

export function generateStandAloneLink(content, index, refFileObj) {
    var element = refFileObj.find(function (element) {
        return element.ID == content.split("%").join('');
    });

    return (
        <div key={'contentItem-' + index} style={{ textAlign: "left", marginTop: "15px" }}>
            <a style={styles.links} key={'contentItemLink-' + index} href={element.path} target='_blank' >{element.linkText}</a>
        </div>
    )
}

 export function generateVideo(content, index, refFileObj) {
    var element = refFileObj.find(function (element) {
        return element.ID == content.split("%").join('');
    });

    return (
        <div key={refFileObj.ID+'-video-container'} className="videoContainer" style={styles.videoPaperStyle}>
            <p key={refFileObj.ID+'-video-title'} style={styles.videoHeader} >{element.title}</p>
            <ReactPlayer url={element.path} controls style={styles.videoPlayer} width={'80%'} />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/dynamic/DynamicConentGeneratorFunctions.js